import {
  CheckboxStandalone,
  Spread,
  IconChevron,
  Box,
  Stack,
} from 'braid-design-system';
import type { ReactNode } from 'react';

import { ResponsiveText } from '../ResponsiveText';

interface AccordionItemBaseProps {
  children: ReactNode;
  id: string;
  onSelect: () => void;
  expanded: boolean;
  disabled: boolean;
  isSelected: boolean;
  label: string;
  onToggle: () => void;
}

export const QuestionItem = ({
  children,
  id,
  onSelect,
  label,
  expanded,
  disabled,
  isSelected,
  onToggle,
}: AccordionItemBaseProps) => (
  <Stack space="large">
    <Box
      aria-controls={id}
      aria-expanded={expanded}
      cursor="pointer"
      onClick={onToggle}
    >
      <Spread space="small">
        <ResponsiveText
          size={{ mobile: 'standard', tablet: 'small' }}
          fallbackSize="small"
          weight="medium"
          icon={
            <CheckboxStandalone
              id={`${id}-checkbox`}
              aria-label={label}
              size="small"
              disabled={disabled}
              checked={isSelected}
              onChange={onSelect}
            />
          }
        >
          {label}
        </ResponsiveText>

        <ResponsiveText
          size={{ mobile: 'standard', tablet: 'small' }}
          fallbackSize="small"
          weight="medium"
        >
          <IconChevron direction={expanded ? 'up' : 'down'} />
        </ResponsiveText>
      </Spread>
    </Box>
    <Box id={id} display={expanded ? 'block' : 'none'}>
      {children}
    </Box>
  </Stack>
);
